import { Expose } from "class-transformer";
import { CompanyWorkplaceBase } from "domain/model/base";

export default class CompanyWorkplace extends CompanyWorkplaceBase {
    
};